import { fetchJSON } from '@bonnet/core/fetch';

import { cmApiUrl } from '@atc/cm-api-url';

export default async (query = {}) => {
    const modelYearsData = await fetchJSON(cmApiUrl('/rest/lsc/crawl/newmodelyears'), {
        circuitBreaker: {
            id: 'crawlPathNewModelYears',
            timeout: 3000,
            resetTimeout: 300000,
            fallback: {
                error: 'Circuit Breaker for /rest/lsc/crawl/newmodelyears is open',
            },
        },
        query,
        headers: {
            'X-fwd-svc': 'atc',
        },
    });
    return modelYearsData || {};
};
